import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

export const FlipText = styled(motion.p, {
  shouldForwardProp: (prop) => prop !== 'hasText',
})(({ theme, hasText }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  height: '100%',
  ...(hasText
    ? {
        width: '100%',
        padding: '0 44px',

        [theme.breakpoints.down('2xl')]: {
          padding: '0 34px',
        },
        [theme.breakpoints.down('lg')]: {
          padding: '0 30px',
        },
      }
    : {
        width: '50px',

        [theme.breakpoints.down('2xl')]: {
          width: '44px',
        },
        [theme.breakpoints.down('lg')]: {
          width: '40px',
        },
      }),
}));

export const LetterWrapper = styled('span')({
  position: 'relative',
  display: 'flex',
  overflow: 'hidden',
});

export const LetterContainer = styled('span')({
  position: 'relative',
});

export const FirstLetter = styled(motion.span)({
  display: 'inline-block',
});

export const SecondLetter = styled(motion.span)({
  position: 'absolute',
  left: 0,
  display: 'inline-block',
});
